export default "__VITE_ASSET__15963288__"